module.exports = __webpack_public_path__ + "static/media/IconTemplates_-82.03f22bae.svg";